<template>
    <div class="App">
    <!-- add after this -->

    <!-- start breadbrumbs -->
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Map</li>
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12">
			<div class="cw-content-nosidenav">
				<!-- ***** start custom content ***** -->
				<h1>Map</h1>

                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-12 mb-4">
                                <vue-simple-suggest id="addressSearch" placeholder="Search an address" :debounce="0" v-model="searchData" autocomplete="off" display-attribute="address" value-attribute="linkid" :list="getAddressList" v-on:select="selectAddress"></vue-simple-suggest>
                                <!--<button class="btn btn-search" @click="searchAddress" role="button" title="" id="wpgsearchbtn"><i aria-hidden="true" class="far fa-search"></i></button>-->
                            </div>
                        </div>
                        <h2 class="h4 mt-4 mb-3">Filter by:</h2>
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-12 mb-4">
                                <label for="buildingType" class="h5">Building category:</label>
                                <select id="buildingType" v-model="category" @change="filteredData" class="form-control selectpicker select-btn  dropdown-toggle searchParams">
                                    <option>All</option>
                                    <option v-for="(c, index) in categoryList" :key="index">
                                        {{ c }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-6 col-lg-12 mb-4">
                                <label for="propertyType" class="h5">Property type:</label>
                                <select id="propertyType" v-model="propertyType" @change="filteredPropertyTypeData" class="form-control selectpicker select-btn  dropdown-toggle searchParams">
                                    <option>All</option>
                                    <option v-for="(c, index) in propertyTypeList" :key="index">
                                        {{ c }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 mb-4">
                                <h3 class="h5">Building size (sq. m):</h3>
                                <div class="form-row">
                                    <div class="col-6 col-lg-6 col-md-3">
                                        <label for="minBuildingSize">Minimum size</label>
                                        <select v-model="minBuildingSize" @change="filteredData" class="form-control selectpicker select-btn  dropdown-toggle searchParams">
                                            <option value="">All</option>
                                            <option value="0">0</option>
                                            <option value="2000">2,000</option>
                                            <option value="4000">4,000</option>
                                            <option value="8000">8,000</option>
                                            <option value="10000">10,000</option>
                                            <option value="20000">20,000</option>
                                            <option value="30000">30,000</option>
                                            <option value="40000">40,000</option>
                                            <option value="50000">50,000</option>
                                            <option value="60000">60,000</option>
                                        </select>
                                    </div>
                                    <div class="col-6 col-lg-6 col-md-3">
                                        <label for="maxBuildingSize">Maximum size</label>
                                        <select v-model="maxBuildingSize" @change="filteredData" class="form-control selectpicker select-btn  dropdown-toggle searchParams">
                                            <option value="">All</option>
                                            <option value="2000">2,000</option>
                                            <option value="4000">4,000</option>
                                            <option value="8000">8,000</option>
                                            <option value="10000">10,000</option>
                                            <option value="20000">20,000</option>
                                            <option value="30000">30,000</option>
                                            <option value="40000">40,000</option>
                                            <option value="50000">50,000</option>
                                            <option value="60000">60,000</option>
                                            <option value="64000">64,000</option>
                                            <option value="70000">70,000</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mb-5">
                                <h3 class="h5">Year built:</h3>
                                <div class="form-row">
                                    <div class="col-6 col-lg-6 col-md-3">
                                        <label for="minYear">Minimum year</label>
                                        <select v-model="minYear" @change="filteredData" class="form-control selectpicker select-btn  dropdown-toggle searchParams">
                                            <option value="">All</option>
                                            <option value="1850">1850</option>
                                            <option value="1875">1875</option>
                                            <option value="1900">1900</option>
                                            <option value="1925">1925</option>
                                            <option value="1950">1950</option>
                                            <option value="1975">1975</option>
                                            <option value="2000">2000</option>
                                            <option value="2010">2010</option>
                                        </select>
                                    </div>
                                    <div class="col-6 col-lg-6 col-md-3">
                                        <label for="maxYear">Maximum year</label>
                                        <select v-model="maxYear" @change="filteredData" class="form-control selectpicker select-btn  dropdown-toggle searchParams">
                                            <option value="">All</option>
                                            <option value="1875">1875</option>
                                            <option value="1900">1900</option>
                                            <option value="1925">1925</option>
                                            <option value="1950">1950</option>
                                            <option value="1975">1975</option>
                                            <option value="2000">2000</option>
                                            <option value="2010">2010</option>
                                            <option value="2020">2020</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-8">
                        <div ref="mymap" style="width: 100%; height:510px"></div>
                    </div>
                </div>

                <div class="callout callout-info">
                    <p>View <a href="https://data.winnipeg.ca/Water-and-Waste/Building-Energy-Disclosure-Project-Information-and/q5ew-mccs">Building Energy Disclosure Project information and metrics</a> on Open Data</p>
                </div>




            </div>
			</main>
		</div>

    <!-- add before this -->
    </div>
</template>
<script>
    //import MarkerClusterer from '@google/markerclusterer';
    import OpenData from '@/libraries/OpenData'
    //import $ from 'jquery';
    import gmapsInit from '@/libraries/gmaps';
    import VueSimpleSuggest from "vue-simple-suggest";
    import "vue-simple-suggest/dist/styles.css";

    const WINNIPEG_CENTRE = { lat: 49.86, lng: -97.158465 };

    export default {
        name: `map-page`,
        components: {
            VueSimpleSuggest,
        },
        data() {
            return {
                jsonData: [],
                category: "All",
                categoryList: [],
                minBuildingSize: "",
                maxBuildingSize: "",
                minYear: "",
                maxYear: "",
                google: null,
                map: null,
                searchData: "",
                propertyType: "All",
                propertyTypeList: [],
            }
        },
        computed: {
            parameters() {
                let where_parameters = this.filters;

                return { where_parameters }
            },
            filters() {
                let where_parameters = [];

                if (this.category !== "All")
                    where_parameters.push([{ column: 'building_category', type: '=', params: [this.category] }]);

                if (this.propertyType !== "All")
                    where_parameters.push([{ column: 'property_type', type: '=', params: [this.propertyType] }]);

                if (this.maxBuildingSize) {
                    where_parameters.push([{ column: 'property_gfa_m', type: '<=', params: [this.maxBuildingSize] }]);
                }
                if (this.minBuildingSize) {
                    where_parameters.push([{ column: 'property_gfa_m', type: '>=', params: [this.minBuildingSize] }]);
                }
                if (this.minYear) {
                    where_parameters.push([{ column: 'year_built', type: '>=', params: [this.minYear] }]);
                }
                if (this.maxYear) {
                    where_parameters.push([{ column: 'year_built', type: '<=', params: [this.maxYear] }]);
                }

                return where_parameters;
            },
        },
        created() {
            this.getCategory();
            this.get_items();
        },
        methods: {
            async getCategory() {
                let apiURL = "https://data.winnipeg.ca/resource/q5ew-mccs.json";
                let geometry_data = await OpenData.getResults(apiURL, this.parameters);

                this.categoryList = [];

                for (let i = 0; i < geometry_data.length; i++) {
                    let item = geometry_data[i];

                    let buildingCategoryExist = this.categoryList.includes(item.building_category);
                    if (!buildingCategoryExist)
                        this.categoryList.push(item.building_category);
                }
            },
            getAddressList(query) {
                return fetch('https://mapapi.winnipeg.ca/mapapi/autocompletelookupjson.ashx?stype=lookup3&q=' + query, { method: 'GET' })
                    .then(response => response.json())
                    .then(json => json.searchresult); /*
            returns a promise with a list of star-wars characters
            */
            },
            selectAddress(result) {
                // this.searchResultData = result;
                var lat = result.lat;
                var lng = result.lon;

                // var myIcon = L.icon({
                //     iconUrl: 'marker-icon.png',
                // });

                // add a marker
                //L.marker([lat, lng], {icon: myIcon}).addTo(this.map);

                // change to zoom level 19 when search result is selected
                let zoom = 19;

                let pt = new this.google.maps.LatLng(lat, lng);

                this.map.panTo(pt);
                this.map.setZoom(zoom);
            },
            async get_items() {
                let apiURL = "https://data.winnipeg.ca/resource/q5ew-mccs.json";
                let geometry_data = await OpenData.getResults(apiURL, this.parameters);

                let data = [];
                let features = [];

                for (let i = 0; i < geometry_data.length; i++) {
                    let item = geometry_data[i];
                    let lat = item.location.coordinates[1];
                    let lng = item.location.coordinates[0];
                    let energy_star_score = item.energy_star_score;
                    if (typeof (energy_star_score) === "undefined")
                        energy_star_score = "NA";

                    let feature = {
                        "type": "Feature",
                        "properties": {
                            "address": item.address,
                            "building_category": item.building_category,
                            "ghg_emissions_intensity_kgco2e_m": item.ghg_emissions_intensity_kgco2e_m,
                            "property_gfa_m": item.property_gfa_m,
                            "property_name": item.property_name,
                            "property_type": item.property_type,
                            "weather_normalized_site_eui_gj_m": item.weather_normalized_site_eui_gj_m,
                            "year_built": item.year_built,
                            "year": item.year,
                            "energy_star_score": energy_star_score
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [lng, lat]
                        }
                    };
                    features.push(feature);
                }
                data = {
                    "type": "FeatureCollection",
                    "features": features
                };
                this.jsonData = data;

                try {
                    this.google = await gmapsInit();
                    //const geocoder = new google.maps.Geocoder();
                    this.map = new this.google.maps.Map(this.$refs.mymap, {
                        center: WINNIPEG_CENTRE,
                        zoom: 12
                    });
                    //console.dir(this.$el);

                    this.map.data.addGeoJson(data);
                    //console.log(data);
                    //listen for click events
                    let infoWindow = new this.google.maps.InfoWindow({
                        content: ""
                    });

                    this.map.data.addListener('click', function (event) {
                        //show an infowindow on click
                        //console.log(event);
                        let item = event.feature;
                        //let content = itemContent(item);
                        let result = "<table class='table'>";
                        let rowColor = "white";

                        let property_name = item.getProperty("property_name");
                        let property_type = item.getProperty("property_type");
                        let address = item.getProperty("address");
                        let building_category = item.getProperty("building_category");
                        let dataYear = item.getProperty("year");
                        let year = "";
                        if (typeof (dataYear) !== "undefined") {
                            let date = new Date(dataYear);
                            year = date.getFullYear();
                        }
                        let weather_normalized_site_eui_gj_m = item.getProperty("weather_normalized_site_eui_gj_m");
                        let ghg_emissions_intensity_kgco2e_m = item.getProperty("ghg_emissions_intensity_kgco2e_m");
                        let property_gfa_m = item.getProperty("property_gfa_m");
                        let yearBuilt = item.getProperty("year_built");
                        let year_built = "";
                        if (typeof (yearBuilt) !== "undefined") {
                            let date = new Date(yearBuilt);
                            year_built = date.getFullYear();
                        }
                        let energy_star_score = item.getProperty("energy_star_score");

                        result += "<tr style='background-color:#80808038'>"
                            + "<td scope='col' nowrap>Property name</td> "
                            + "<td nowrap> " + property_name + "</td></tr> ";

                        let toolTip = "The property type indicates the single, primary use of your property. For a single multi-use building, this is the property type that accounts for more than 50% of your property. For more information please click here.";

                        result += "<tr style='background-color:" + rowColor + "'>"
                            + "<td scope='col' nowrap title='" + toolTip + "'><a href='https://portfoliomanager.energystar.gov/pm/glossary#PropertyType' target='_blank'>Property type</a></td> "
                            + "<td nowrap> " + property_type + "</td></tr> ";

                        result += "<tr style='background-color:#80808038'>"
                            + "<td scope='col' nowrap>Data year</td> "
                            + "<td nowrap> " + year + "</td></tr> ";

                        toolTip = "The ENERGY STAR Score is a measure of how well your property is performing relative to similar properties nationwide, when normalized for climate and operational characteristics. " +
                            "A score of 50 is the median.If your property scores below 50, it means it’s performing lower than 50 % of similar properties nationwide, while a score above 50 means it’s performing better than 50 % of its peers.A score of 75 or higher means it’s a top performer and may be eligible for ENERGY STAR certification. For more information please click here.";

                        result += "<tr style='background-color:" + rowColor + "'>"
                            + "<td scope='col' nowrap title='" + toolTip + "'><a href='https://portfoliomanager.energystar.gov/pm/glossary#EnergyStarScore' target='_blank'>Energy star score</a></td> "
                            + "<td nowrap> " + energy_star_score + "</td></tr> ";

                        result += "<tr style='background-color:#80808038'>"
                            + "<td scope='col' nowrap>Building category</td> "
                            + "<td nowrap> " + building_category + "</td></tr> ";

                        result += "<tr style='background-color:" + rowColor + "'>"
                            + "<td scope='col' nowrap>Address</td> "
                            + "<td nowrap> " + address + "</td></tr> ";

                        toolTip = "The Gross Floor Area (GFA) is the total property square footage between the outside surface of the exterior walls of the building(s). This includes all areas inside the building(s) including supporting areas. GFA is not the same as rentable space, but rather includes all area inside the building(s). For more information please click here.";

                        result += "<tr style='background-color:#80808038'>"
                            + "<td scope='col' nowrap title='" + toolTip + "'><a href='https://portfoliomanager.energystar.gov/pm/glossary#GrossFloorArea' target='_blank'>Property GFA (m2)</a></td> "
                            + "<td nowrap> " + property_gfa_m + "</td></tr> ";

                        toolTip = "Greenhouse Gas (GHG) emissions are the carbon dioxide (CO2), methane (CH4), and nitrous oxide (N2O) gases released into the atmosphere as a result of energy consumption at the property. GHG emissions are expressed in carbon dioxide equivalent (CO2e), a universal unit of measure that combines the quantity and global warming potential of each greenhouse gas. Emissions are reported as an intensity value in kilograms per square meter (kgCO2e/m2).";

                        result += "<tr style='background-color:" + rowColor + "'>"
                            + "<td scope='col' nowrap title='" + toolTip + "'>GHG emissions intensity (kgCo2e/m2)</td> "
                            + "<td nowrap> " + ghg_emissions_intensity_kgco2e_m + "</td></tr> ";

                        toolTip = "Weather normalized energy is the energy your building would have used under aver¬age conditions. The weather in a given year may be much hotter or colder than your building’s normal climate; weather normalized energy accounts for this difference. Site Energy Use intensity (EUI) is the Site Energy Use divided by the property square meter(GJ/m2).";

                        result += "<tr style='background-color:#80808038'>"
                            + "<td scope='col' nowrap title='" + toolTip + "'>Weather normalized site EUI (GJ/m2)</td> "
                            + "<td nowrap> " + weather_normalized_site_eui_gj_m + "</td></tr> ";

                        toolTip = "This is the year in which your property was constructed. If your property has undergone a complete renovation that included gutting and rebuilding the interior, then you can indicate the date of this renovation as the year built. The year built is not used to calculate the ENERGY STAR Score; it is simply for property information.";

                        result += "<tr style='background-color:" + rowColor + "'>"
                            + "<td scope='col' nowrap title='" + toolTip + "'>Year built</td> "
                            + "<td nowrap> " + year_built + "</td></tr> ";

                        result += "</table>";
                        let content = result;

                        //console.log(content);

                        //let content = "<table><tr><td>"
                        infoWindow.setContent(content);
                        //infoWindow.setContent('<div style="line-height:1.35;overflow:hidden;white-space:nowrap;"> Feature id = ' +
                        //    i.address + "<br/>Feature Value = Zone " + event.feature.getProperty("address") + "</div>");
                        //var anchor = new this.google.maps.MVCObject();
                        //anchor.set("position", event.latLng);
                        infoWindow.setPosition(event.latLng);
                        infoWindow.open(this.map);
                    });
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
            },

            filteredData() {
                this.propertyType = "All";
                this.get_items();
                if (this.category === "All") {
                    this.propertyTypeList = [];
                }
                else {
                    this.getPropertyType();
                }
            },

            filteredPropertyTypeData() {
                this.get_items();
            },
            async getPropertyType() {
                let apiURL = "https://data.winnipeg.ca/resource/q5ew-mccs.json";
                let geometry_data = await OpenData.getResults(apiURL, this.parameters);

                this.propertyTypeList = [];

                for (let i = 0; i < geometry_data.length; i++) {
                    let item = geometry_data[i];

                    let propertyTypeExist = this.propertyTypeList.includes(item.property_type);
                    if (!propertyTypeExist)
                        this.propertyTypeList.push(item.property_type);
                }
            },
            async getToolTip() {
                let result = "test";
                alert(result);

                switch (this.toolTipType) {
                    case 1:
                        result = "The ENERGY STAR Score is a measure of how well your property is performing relative to similar properties nationwide, when normalized for climate and operational characteristics.<br />" +
                            "A score of 50 is the median.If your property scores below 50, it means it’s performing lower than 50 % of similar properties nationwide, while a score above 50 means it’s performing better than 50 % of its peers.A score of 75 or higher means it’s a top performer and may be eligible for ENERGY STAR certification.For more information please <a href='https://portfoliomanager.energystar.gov/pm/glossary#EnergyStarScore' target='_blank'>click here</a>.";
                        break;
                    case 2:
                        result = "The Gross Floor Area (GFA) is the total property square footage between the outside surface of the exterior walls of the building(s). This includes all areas inside the building(s) including supporting areas. GFA is not the same as rentable space, but rather includes all area inside the building(s). For more information please <a href='https://portfoliomanager.energystar.gov/pm/glossary#GrossFloorArea' target='_blank'>click here</a>.";
                        break;
                    case 3:
                        result = "Greenhouse Gas (GHG) emissions are the carbon dioxide (CO2), methane (CH4), and nitrous oxide (N2O) gases released into the atmosphere as a result of energy consumption at the property. GHG emissions are expressed in carbon dioxide equivalent (CO2e), a universal unit of measure that combines the quantity and global warming potential of each greenhouse gas. Emissions are reported as an intensity value in kilograms per square meter (kgCO2e/m2).";
                        break;
                    case 4:
                        result = "Weather normalized energy is the energy your building would have used under aver¬age conditions. The weather in a given year may be much hotter or colder than your building’s normal climate; weather normalized energy accounts for this difference. Site Energy Use intensity (EUI) is the Site Energy Use divided by the property square meter(GJ/m2).";
                        break;
                    case 5:
                        result = "This is the year in which your property was constructed. If your property has undergone a complete renovation that included gutting and rebuilding the interior, then you can indicate the date of this renovation as the year built. The year built is not used to calculate the ENERGY STAR Score; it is simply for property information.";
                        break;
                    case 6:
                        result = "The property type indicates the single, primary use of your property. For a single multi-use building, this is the property type that accounts for more than 50% of your property. For more information please <a href='https://portfoliomanager.energystar.gov/pm/glossary#PropertyType' target='_blank'>click here</a>.";
                        break;
                }
                this.toolTip = result;
            },
            searchAddress() {
                //if ($("#modalWindow2").length == 0) {
                //    //modalWindow=dynamically created div for the thickbox. if does not exsit the create it
                //    $("<div/>") //main div used to display mutiple search return
                //        .attr("id", "modalWindow2")
                //        .css("display", "none")
                //        .appendTo($("#wpgsearchbtn"));
                //    $("<img/>")
                //        .attr("id", "loadingimg")
                //        .attr("src", "https://mapapidev.winnipeg.ca/mapapi/images/loading4.gif")
                //        .attr("alt", "loading")
                //        .css("width", "25px")
                //        .css("height", "25px")
                //        .appendTo($("#modalWindow2"));
                //    $("<ul/>") //acutal ul containing the list
                //        .attr("id", "searchlist")
                //        .addClass("wpg-dialog")
                //        .appendTo($("#modalWindow2"));
                //} else {
                //    $("<img/>")
                //        .attr("id", "loadingimg")
                //        .attr("src", "http://mapapidev.winnipeg.ca/mapapi/images/loading4.gif")
                //        .attr("alt", "loading")
                //        .css("width", "25px")
                //        .css("height", "25px")
                //        .appendTo($("#modalWindow2"));
                //    $("#searchlist").empty();
                //} // end if ($("#modalWindow2").length == 0) {
                ////close autocomplete window
                //$("#modalWindow2").dialog({
                //    height: 200,
                //    modal: true,
                //    title: 'Search Result',
                //    show: '',
                //    hide: '',
                //    close: function () { }
                //});
                ////ajax call to get result and populate search list ul
                //$.ajax({
                //    url: 'http://wpgmapapidev/mapapi/autocompletelookupjson.ashx' + '?q=' + $("#wpgsearchtxt").val().replace("&", "%26") + '&stype=query&callback=?',
                //    dataType: 'json',
                //    success: function (data) {
                //        $("#loadingimg").remove();
                //        data = data.searchresult;
                //        //old startthickbox(data);
                //        $("#searchlist").empty();
                //        //need for IE 6.0 for hover to work
                //        //var headerli = $("<li/>").appendTo($("#searchlist"));
                //        for (var i = 0; i < data.length; i++) {
                //            $("<li/>")
                //                .html(data[i].address)
                //                //.addClass(i % 2 == 0 ? "wpg_odd" : "wpg_even")
                //                .attr("SearchPara", data[i].address)
                //                .click(function () {
                //                    var temparray = $(this).attr("SearchPara");
                //                    alert('do something with the value' + temparray);
                //                    $("#modalWindow2").dialog('close');
                //                })//end .click(function () {
                //                .mouseover(function () { $(this).addClass("wpg_over") })
                //                .mouseout(function () { $(this).removeClass("wpg_over") })
                //                .appendTo($("#searchlist"));
                //        } //end for (var i = 0; i < cont.length; i++) {
                //    } // end success: function (data) {
                //});
            }
        }
    };
</script>

<style>
</style>
